export const RQ_GET_LEAVE_BALANCE_REPORTS_API = {
  url:'leavebalance/data-list/<%= locationId %>/<%= year %>',
  method:'GET',
  auth:true,
};
